import { Card } from '../../components/core/Card.jsx'
import { AdminLayout, Table } from '../../admin/AdminLayout.jsx'

// Every customer business, and the industries customers typed themselves,
// grouped — three separate accounts in one group makes it a candidate for the
// shared list, by the 2026-10-12 decision.
export default function AdminBusinesses({ businesses = [], typed_groups = [] }) {
  const rows = businesses.map((b) => ({
    ...b,
    industry_cell: b.typed ? `${b.industry} (typed)` : b.industry,
    state: b.awaiting_review ? 'Questions awaiting review' : b.last_collected ? 'Collecting' : 'Not collected yet',
  }))

  return (
    <AdminLayout title="Businesses">
      <Card pad="md" title="Typed industries" description="Grouped by the name the generator gave them. Three accounts makes a candidate for the list.">
        <Table
          columns={[[ 'group', 'Group' ], [ 'accounts', 'Accounts', 'right' ], [ 'businesses', 'Businesses', 'right' ]]}
          rows={typed_groups.map((g) => ({ ...g, id: g.group }))}
          empty="No customer has typed an industry yet."
        />
      </Card>
      <Card pad="md" title="All businesses">
        <Table
          columns={[
            ['name', 'Business'], ['account', 'Account'], ['industry_cell', 'Industry'], ['place', 'Market'],
            ['state', 'State'], ['last_collected', 'Last collected'], ['next_due', 'Next due'], ['created', 'Created'],
          ]}
          rows={rows}
          empty="No customer businesses yet."
        />
      </Card>
    </AdminLayout>
  )
}
